import React from 'react';
import PropTypes from 'prop-types';
import { Select, TextInput } from '@mantine/core';
import CustomSelect from './CustomSelect';

const FilterInput = ({
  type,
  label,
  value,
  untrackedValue,
  onChange,
  data,
  ...rest
}) =>
  type === 'select' ? (
    <Select
      data={data}
      label={label}
      onChange={onChange}
      value={value}
      withCheckIcon={false}
      {...rest}
    />
  ) : type === 'custom-select' ? (
    <CustomSelect
      data={data}
      label={label}
      onChange={onChange}
      value={value ?? ''}
      {...rest}
    />
  ) : (
    <TextInput
      label={label}
      onChange={(e) => onChange(e.currentTarget.value)}
      placeholder="Filter by registrant"
      value={untrackedValue ? undefined : value || ''}
      {...rest}
    />
  );

FilterInput.propTypes = {
  data: PropTypes.array,
  label: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  untrackedValue: PropTypes.bool,
  value: PropTypes.string
};

export default FilterInput;
